/* eslint-disable react/display-name */
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { MultiSelectV2 } from '@smartsheet/lodestar-core';
import React, { useCallback } from 'react';

export interface ChipType extends Record<string, string | number | boolean> {
  label: string;
  value: string | number | boolean;
}

export interface InputMultiSelectProps extends EntityId {
  value: Array<string | number | boolean>;
  options: ChipType[];
  onChange: (value?: Array<string | number | boolean>) => void;
  onCreateOption?: (value: string) => void;
}

export const InputMultiSelect = React.memo(
  ({
    id,
    value = [],
    options = [],
    onChange,
    onCreateOption,
  }: InputMultiSelectProps) => {
    const getOptionLabel = useCallback((chip: ChipType) => chip.label, []);
    const onChangeHandler = useCallback(
      chips =>
        onChange(
          (chips && chips.map((chip: { value: any }) => chip.value)) || []
        ),
      [onChange]
    );
    const chipValue = options.filter(option => value.includes(option.value));

    return (
      (<MultiSelectV2
        id={id}
        locale="en"
        options={options}
        selectedOptions={chipValue}
        getOptionKey={option => option.value as string}
        onChange={onChangeHandler}
        optionToString={getOptionLabel}
        onCreateOption={onCreateOption}
        isClearable={true} />)
    );
  }
);
